module.exports = __webpack_public_path__ + "assets/img/dzh-36.c9fbcd9f.jpg";